import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const LanguageSwitcher = () => {
  const [currentLang, setCurrentLang] = useState('en');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if URL contains /fr/ for French
    const isFrench = location.pathname.startsWith('/fr');
    setCurrentLang(isFrench ? 'fr' : 'en');
  }, [location]);

  const switchLanguage = (lang) => {
    let newPath = location.pathname;
    
    if (lang === 'fr') {
      // Add /fr/ prefix if not already present
      if (!newPath.startsWith('/fr')) {
        newPath = `/fr${newPath}`;
      }
    } else {
      // Remove /fr/ prefix for English
      if (newPath.startsWith('/fr')) {
        newPath = newPath.replace('/fr', '');
      }
    }
    
    setCurrentLang(lang);
    navigate(newPath);
    
    // Update document language
    document.documentElement.lang = lang;
  };

  return (
    <div className="flex items-center space-x-2">
      <button
        onClick={() => switchLanguage('en')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
          currentLang === 'en'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        EN
      </button>
      <button
        onClick={() => switchLanguage('fr')}
        className={`px-3 py-1 rounded-md text-sm font-medium transition-colors ${
          currentLang === 'fr'
            ? 'bg-blue-600 text-white'
            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
        }`}
      >
        FR
      </button>
    </div>
  );
};

export default LanguageSwitcher; 